<div class="input-group mb-3">
  <ng-autocomplete
          #autocomplete
          placeholder="Enter Store Name"
          class="w-100"
          [data]="dataService.stores"
          [ngModel]="selectedStore ? selectedStore.name : ''"
          [searchKeyword]="'name'"
          (selected)="storeSelected($event)"
          [itemTemplate]="itemTemplate"
          (inputCleared)="clearSelection()"
          [notFoundTemplate]="notFoundTemplate">
  </ng-autocomplete>

  <ng-template #itemTemplate let-item>
    <a [innerHTML]="item.name"></a>
  </ng-template>

  <ng-template #notFoundTemplate let-notFound>
    <div [innerHTML]="notFound"></div>
  </ng-template>
</div>
